import { render, staticRenderFns } from "./bingp.vue?vue&type=template&id=140c2bba&scoped=true&"
import script from "./bingp.vue?vue&type=script&lang=js&"
export * from "./bingp.vue?vue&type=script&lang=js&"
import style0 from "./bingp.vue?vue&type=style&index=0&id=140c2bba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140c2bba",
  null
  
)

export default component.exports